import React, { FC } from 'react';


interface SelectBox {
  title: string;
  icon?: string;
  multi?: boolean;
  isSelected?: boolean;
  removable?: boolean;
  onClick?: () => void;
  onClickX?: () => void;
}

const SelectBox: FC<SelectBox> = ({
  title,
  icon,
  multi = false,
  isSelected = false,
  removable = false,
  onClick= () => null,
  onClickX= () => null,
  children
}): JSX.Element => {
  return (
    <div
      onClick={onClick}
      className={`select-box ${multi ? 'multi' : ''} ${removable ? 'removable' : ''} ${isSelected ? 'selected' : ''}`}
    >
      {removable && (
        <div className="select-box-remove">
          <img
            onClick={onClickX}
            src={`${process.env.PUBLIC_URL}/assets/images/remove-icon.png`} alt=""/>
        </div>
      )}

      {isSelected && (
        <div className="select-box-selected">
          <img src={`${process.env.PUBLIC_URL}/assets/images/selected-icon.png`} alt=""/>
        </div>
      )}

      {icon && (
        <div className="select-box-icon">
          <img src={`${process.env.PUBLIC_URL}/assets/images/${icon}.png`} alt=""/>
        </div>
      )}

      <div className="select-box-title">{title}</div>

      {children}
    </div>
  );
};

export default SelectBox;
